export const metadataKeys = {
  all: ['metadata'] as const,

  lists: () => [...metadataKeys.all, 'list'] as const,
};
